import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () => {
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint, withCredentials: true });
    return {
        listDrafts: (filter) => client.request({
            method: 'POST',
            url: '/drafts',
            data: filter
        }),
        createDraft: (draft) => client.request({
            method: 'POST',
            url: '/drafts/create',
            data: draft
        }),
        updateDraft: (draft) => client.request({
            method: 'PUT',
            url: '/drafts',
            data: draft
        }),
        deleteDraft: (id) => client.request({
            method: 'DELETE',
            url: `/drafts/${id}`
        }),
        sendDraft: (data) => client.request({
            method: 'POST',
            url: '/drafts/send',
            data
        }),
        deliverDraft: (data) => client.request({
            method: 'POST',
            url: '/drafts/deliver',
            data
        }),
        validateCustomer: (data) => client.request({
            method: 'POST',
            url: '/drafts/validate-customer',
            data
        }),
        convertDraft: (data) => client.request({
            method: 'POST',
            url: '/drafts/convert',
            data
        }),
        completeDraft: (data) => client.request({
            method: 'POST',
            url: '/drafts/complete',
            data
        }),
        exportDraft: (data) => client.request({
            method: 'POST',
            url: '/drafts/export',
            data
        }),
        searchCustomers: (query) => client.request({
            method: 'GET',
            url: `/drafts/customers?query=${encodeURIComponent(query)}`
        }),
        duplicateDraft: (data) => client.request({
            method: 'POST',
            url: '/drafts/duplicate',
            data
        }),
        importShopifyDrafts: () => client.request({
            method: 'POST',
            url: '/drafts/import'
        }),
        issueManualInvoice: (data) => client.request({
            method: 'POST',
            url: '/drafts/issue',
            data
        }),
        exportDraftsBulk: (data) => client.request({
            method: 'POST',
            url: '/drafts/export-bulk',
            data
        })
    };
};



// WEBPACK FOOTER //
// app/services/drafts.js